import type { FaireProductEntity } from "../../entity_types/product";

export const p_9xzne7q8b6: FaireProductEntity = {
  token: "p_9xzne7q8b6",
  type: "product",
  name: "Sweatpant Love Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/49db4d54940b84a184a3c8e1d77f23cfe926edf3845f7e133db008a0b705a3fa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/589e661f88adb43a831b77d983e530ea864d3f583d411b387682010ca0e0a32f.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:34.482Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
